const data = {
  backend: "https://muarif-back.onrender.com",
  GOOGLE_MEET: "http://meet.google.com/twv-pkwa-efv",
  PHONE: "tel:+989388030994",
  EMAIL: "mailto:sajjadnaqvi9797@gmail.com",
  TELEGRAM: "https://t.me/short_islamic_courses",
  FACEBOOK_OFFICIAL: "https://www.facebook.com/profile.php?id=100066520402771",
  YOUTUBE_OFFICIAL: "https://youtube.com/channel/UCaNz-RHNVPeH8akC_lYsFWA",
  WHATSAPP_ONE: "https://chat.whatsapp.com/L1Pj9v7GepR1RgRSggrFQL",
  WHATSAPP_TWO: "https://chat.whatsapp.com/EsUysEO4AufA6501lQ4z5f",
  WHATSAPP_THREE: "https://chat.whatsapp.com/Hi4OC3oy765Bn2Rg0AX26p",
  WHATSAPP_FOUR: "https://chat.whatsapp.com/Lx5cuKA5pGcDp8G866VjuH",
  WHATSAPP_PERSONAL:
    "https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?",
  WHATSAPP_LADIES: "https://chat.whatsapp.com/If4BNh22thdHxCPmDT4b3x",
  FACEBOOK_PERSONAL: "https://www.facebook.com/SajjadNaqv",
  IMAGE_URL: "https://muarif-back.onrender.com/galleryUpload",
  LECTURE_URL: "https://muarif-back.onrender.com/create",
  LOGIN: "https://muarif-back.onrender.com/login",
  REGISTER: "https://muarif-back.onrender.com/register",
  COURSE_URL: "https://muarif-back.onrender.com/courseUpload",
  PASSWORD_UPDATE: "https://muarif-back.onrender.com/update",
  GALLERY_FETCH: "https://muarif-back.onrender.com/gallery",
  STUDENTS: "https://muarif-back.onrender.com/students",
  COURSES: "https://muarif-back.onrender.com/courses",
  LECTURES: "https://muarif-back.onrender.com/lectures",
};

export default data;
